import * as yup from "yup";

import { nameStatusSchemaShape } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";

export const schema = yup.object().shape({
  ...nameStatusSchemaShape,
  group: yup.object().shape({
    label: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
    value: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
  }),
});
